import React, { useState, useEffect, useCallback } from "react";

import { useParams } from 'react-router-dom';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Text,
  Heading,
  Button,
  useToast,
  useColorModeValue,
  useDisclosure,
    Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
SimpleGrid,
VStack,

} from "@chakra-ui/react";
import axios from "axios";
import { FiTrash, FiCheck, FiX, FiEdit } from "react-icons/fi";
import { jwtDecode } from "jwt-decode";
import { PracticeSet,QuestionSet, PracticeSetQset, QuestionSetCategory,PracticeSetSection, PracticeSetGroup, PracticeSetExam } from '../../Platform/Common/types';
import { addMinutes } from 'date-fns'; // You can also manually add mins without this
import ReactSelect from 'react-select';
import { useNavigate } from "react-router-dom";
import { Product } from '../../Platform/Common/types';
import PracticeSetGroupQsets from "../Components/PracticeSetGroupQsets";
import PracticeSetExamQsets from "./PracticeSetExamQsets";



interface PracticeSetExamsProps {
    practiceSetId:number;
    isPsetEditing:boolean;
  }


  const PracticeSetExams: React.FC<PracticeSetExamsProps> = ({ practiceSetId, isPsetEditing}) => {
    // ────────────────────────────────────────────────────────────────────────────
    // Theme & routing hooks
    // ────────────────────────────────────────────────────────────────────────────

    const cardbg = useColorModeValue("gray.50", "gray.700");
  
  //  const { practice_set_id } = useParams<{ practice_set_id: string }>();
    //const [practiceSetId, setPracticeSetId] = useState<number>(Number(practice_set_id));
    const navigate = useNavigate();
    const toast = useToast();

  
    // ────────────────────────────────────────────────────────────────────────────
    // State: core practiceSet, question-sets, mappings
    // ────────────────────────────────────────────────────────────────────────────

  
    const [practiceSetExams, setPracticeSetExams] = useState<PracticeSetExam[]>([]);

    const [products, setProducts] = useState<Product[]>([]);
   // const [availableQuestionSetGroups, setAvailableQuestionSetGroups] = useState<QuestionSetGroup[]>([]);

    const [isPsetEdited, setIsPsetEdited] = useState(false);
  
    const [isPracticeSetEdited, setIsPracticeSetEdited] = useState(false);

    const [newExamTitle, setNewExamTitle] = useState<string>(""); // Initialize with an empty string

    const [newExamDescription, setNewExamDescription] = useState<string>(""); // Initialize with an empty string

    const [newExamIntervalDuration, setNewExamIntervalDuration] = useState<number >(5); // Initialize with an empty string

    const [newPassingPercentage, setNewPassingPercentage] = useState<number >(20); // Initialize with an empty string

    const [newMaxAttempts, setNewMaxAttempts] = useState<number | "">(""); // Initialize with an empty string
  
  
    // ────────────────────────────────────────────────────────────────────────────
    // Mode & button logic
    // ────────────────────────────────────────────────────────────────────────────

   
    const [allQuestionSets, setAllQuestionSets] = useState<QuestionSet[]>([]);


    const { isOpen, onOpen, onClose } = useDisclosure(); // Modal controls

     const {
        isOpen: isEditOpen,
        onOpen: onEditOpen,
        onClose: onEditClose,
      } = useDisclosure();
      const {
        isOpen: isDeleteOpen,
        onOpen: onDeleteOpen,
        onClose: onDeleteClose,
      } = useDisclosure();

      const buttonBg = useColorModeValue(
        'linear-gradient(to right, blue.50, blue.100)',
        'linear-gradient(to right, blue.600, blue.700)'
      );

        const buttonHoverBg = useColorModeValue(
          'blue.200',
          'blue.500'
        );

       const {
         isOpen: isGroupNewOpen,
         onOpen: onGroupNewOpen,
         onClose: onGroupNewClose,
       } = useDisclosure();
  
  
    // ────────────────────────────────────────────────────────────────────────────
    // API fetchers
    // ────────────────────────────────────────────────────────────────────────────

    // Write fetchPracticeSetCategories, API has been written and then use Accordion logic - take help from ReviewCourseTerms

    const fetchPracticeSetExams = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<PracticeSetExam[]>(`${b2c_apiurl}/practice-set/${practiceSetId}/exams`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setPracticeSetExams(data);
    };

    
        const fetchAllQuestionSets = async () => {
          const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
          const { data } = await axios.get<QuestionSet[]>(`${b2c_apiurl}/qsets`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
          });
    
          setAllQuestionSets(data);
        };
      

    // 1) On load —  fetch everything
    useEffect(() => {
      (async () => {
        const token = localStorage.getItem("b2c_token");
        if (!token) return;
  
  
        if (Number(practiceSetId) > 0) {
          await fetchPracticeSetExams();
          await fetchAllQuestionSets();

        }

      })();
    }, [practiceSetId]);


  
    // ────────────────────────────────────────────────────────────────────────────
    // Form handlers
    // ──────────────────────────────────────────────────────────────────────────

  
    // ────────────────────────────────────────────────────────────────────────────
    // Save / Create / Update / Publish / Cancel / Terminate
    // ────────────────────────────────────────────────────────────────────────────

        
/*       const handleAddNewExam = async () => {
        if (!newExamTitle) {
          toast({
            title: "Error",
            description: "Please enter a display label for the new exam.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
    
        try {
          const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
          const response = await axios.post(
            `${b2c_apiurl}/practice-set/${practiceSetId}/add-exam`,
            { practice_set_id:practiceSetId,
              title: newExamTitle, 
              description: newExamDescription,
              interval_duration_minutes : newExamIntervalDuration,
              passing_percentage: newPassingPercentage,
              max_attempts : newMaxAttempts,
              is_active:true,
              sequence_number:practiceSetExams.length+1,
            }, // API expects title
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("b2c_token")}`,
              },
            }
          );
          toast({
            title: "Exam Added",
            description: "The new section was successfully created.",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setNewExamTitle(""); // Reset the input field
          fetchPracticeSetExams();
          onClose(); // Close the modal
          // Optionally, refresh terms list
        } catch (error) {
          console.error("Failed to add new exam", error);
          setNewExamTitle(""); // Reset the input field
          onClose(); // Close the modal
          toast({
            title: "Error",
            description: "Failed to add new exam.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
        }
 */

        const handleAddNewExam = async () => {
          if (!newExamTitle.trim()) {
            toast({
              title: "Error",
              description: "Please enter a display label for the new exam.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
            return;
          }

          try {
            const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';

            const payload = {
              practice_set_id: practiceSetId,
              title: newExamTitle,
              description: newExamDescription || "",
              interval_duration_minutes: newExamIntervalDuration || 0,
              passing_percentage: newPassingPercentage || 0,
              max_attempts: newMaxAttempts === "" ? null : Number(newMaxAttempts),   // ← Key fix
              is_active: true,
              sequence_number: practiceSetExams.length + 1,
            };

            const response = await axios.post(
              `${b2c_apiurl}/practice-set/${practiceSetId}/add-exam`,
              payload,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("b2c_token")}`,
                },
              }
            );

            toast({
              title: "Exam Added",
              description: "The new section was successfully created.",
              status: "success",
              duration: 3000,
              isClosable: true,
            });

            // Reset form
            setNewExamTitle("");
            setNewExamDescription("");
            setNewExamIntervalDuration(5);
            setNewPassingPercentage(20);
            setNewMaxAttempts("");

            fetchPracticeSetExams();
            onClose();
          } catch (error) {
            console.error("Failed to add new exam", error);
            toast({
              title: "Error",
              description: "Failed to add new exam.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        };
        const handleExamDeleted = (deletedExamId: number) => {
            setPracticeSetExams(prev =>
                prev.filter(exam => exam.practice_set_exam_id !== deletedExamId)
            );
            };

        const isLastExam = (examSequence: number) => {
            return practiceSetExams.length === examSequence;
            };

    

  return (
    <Box as="main" mx="auto" >

    {/* PracticeSet Exams */}

    {/* Modal for adding a new section */}
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create a New Exam</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">

            <FormControl>
              <FormLabel>Exam Name</FormLabel>
              <Input
                placeholder="Enter new Exam Name"
                value={newExamTitle}
                onChange={(e) => setNewExamTitle(e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Exam Description</FormLabel>
              <Input
                placeholder="Enter new Exam Description"
                value={newExamDescription}
                onChange={(e) => setNewExamDescription(e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Interval Duration (Minutes)</FormLabel>
              <Input
                type="number"
                min={0}
                placeholder="Enter new Exam Interval Duration in Minutes between Question Sets"
                value={newExamIntervalDuration}
                onChange={(e) =>
                  setNewExamIntervalDuration(e.target.value === "" ? 0 : Number(e.target.value))
                }
              />
            </FormControl>

            <FormControl>
              <FormLabel>Passing Percentage</FormLabel>
              <Input
                type="number"
                min={0}
                placeholder="Passing Percentage"
                value={newPassingPercentage}
                onChange={(e) =>
                  setNewPassingPercentage(e.target.value === "" ? 0 : Number(e.target.value))
                }
              />
            </FormControl>

            <FormControl>
              <FormLabel>Maximum Attempts (leave blank for unlimited)</FormLabel>
              <Input
                type="number"
                min={0}
                placeholder="Enter new Overriding Maximum Attempts, keep blank for unlimited attempts"
                value={newMaxAttempts}
                onChange={(e) =>
                  setNewMaxAttempts(e.target.value === "" ? "" : Number(e.target.value))
                }
              />
            </FormControl>

            <Box mt={2} fontSize="sm" color="gray.600">
              The exam will be created last in the existing sequence.
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            ml={3}
            onClick={handleAddNewExam}
            isDisabled={!newExamTitle.trim()}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>


        <Text mb={2} fontSize="md" fontWeight="bold">
          Exams
        </Text>

                {(isPsetEditing) && ( 
              <Box textAlign="left" mt={4}>
                    <Button
                  mb={2} 
                
                  colorScheme="purple"
                  size="sm"
                  borderRadius="sm"
                  onClick={onOpen}
                  >
                  + Exam
                  </Button>

                      </Box>
              )}

            {/* Existing exams */}
                {practiceSetExams.length === 0 ? (
                <Text fontSize="sm" color="gray.500" mt={3}>
                    No exams in this practice set.
                </Text>
                ) : (
                <SimpleGrid columns={2} spacing={3} mt={3}>
                    {practiceSetExams.map((exam) => (
                    <Box
                        key={exam.practice_set_exam_id}
                    >
                        <PracticeSetExamQsets
                        practiceSetId={practiceSetId}
                        examId={exam.practice_set_exam_id}
                        isPsetEditing={isPsetEditing}
                        allQuestionSets={allQuestionSets}
                        onExamDeleted={handleExamDeleted}
                        canDelete={isLastExam(exam.sequence_number)}
                        />
                    </Box>
                    ))}
                </SimpleGrid>
                )}

    </Box>
  );
};

export default PracticeSetExams;
